import * as React from 'react';
import {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import {AppBar} from './AppBar';
import {globalEventEmitter} from '../../common/eventEmitter';
import {SnackbarPayload} from '../../common/types';

// const authConfig = {googleAuthConfig: {allowOnlyUdaan: true}, enableAzureLogin: true};
type SnackbarState = {
    isOpen: boolean;
    message: string;
};

export const Layout: React.FC<React.PropsWithChildren<object>> = (props) => {
    const [snackbarState, setSnackbarState] = useState<SnackbarState | undefined>();
    useEffect(() => {
        globalEventEmitter.on('SHOW_SNACKBAR', (payload: SnackbarPayload) => {
            setSnackbarState({
                isOpen: true,
                message: payload.message,
            });
        });
    }, []);

    return (
        <Box sx={{display: 'flex'}}>
            <AppBar />
            {/* <Drawer /> */}
            <Box component='main' sx={{flexGrow: 1}}>
                {/* <Toolbar /> */}
                {props.children}
            </Box>
            <Snackbar
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                open={snackbarState?.isOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarState(undefined)}
                message={snackbarState?.message}
            />
        </Box>
    );
};
